"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PrinterSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M27 8h-2V3a1 1 0 00-1-1H8a1 1 0 00-1 1v5H5a3 3 0 00-3 3v10a1 1 0 001 1h4v7a1 1 0 001 1h16a1 1 0 001-1v-7h4a1 1 0 001-1V11a3 3 0 00-3-3zm-4 14v6H9V16h14zm0-14H9V4h14zm3 5a1 1 0 111-1 1 1 0 01-1 1z"/><path d="M12.89 21h6.22a1 1 0 000-2h-6.22a1 1 0 000 2zM12.89 25h6.22a1 1 0 000-2h-6.22a1 1 0 000 2z"/>';
var PrinterSVG = function PrinterSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.PrinterSVG = PrinterSVG;
PrinterSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(PrinterSVG);
exports.default = _default;